import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { UserStatusComponent } from './user-status/user-status.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    ColorPickerModule,
    ColorPickerComponent
  ],
  declarations: [
    UserStatusComponent,
  ],
  exports: [
    UserStatusComponent,
    ColorPickerComponent
  ],
})
export class ElementsModule { }
